<template>
	<div>
		<div class="tips">
			<span>请选择历史批次：</span>
			<el-select style="width: 120px;margin: 0 10px;" placeholder="活动区域">
				<el-option label="区域一" value="shanghai"></el-option>
				<el-option label="区域二" value="beijing"></el-option>
			</el-select>
			<span>该批次的薪资所属月份为2020-01，社保月份为2020-01，税金所属月份为2019-12，可点击</span>
			<el-link type="primary" style="margin-left:4px;">查看详细信息</el-link>
		</div>
		<p class="p1">已选表头展示：</p>
		<vxe-grid :data.sync="list" ref="accountTable"  auto-resize :columns="tableColumn">
		</vxe-grid>
		<div class="div1" style="height:36px;">
			<span class="p1">选择要复制的表头：</span>
			<div class="flex">
				<searchBox :dynamicColumn.sync="dynamicColumn"></searchBox>
				<div>
					<el-radio-group v-model="radio" @change="changList">
						<el-radio label="1">选择全部项</el-radio>
						<el-radio label="2">清除项目</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>
		<div class="div1 seachBox">
			<div v-for="(column,i) in dynamicColumn" :key="i">
				<span class="label">{{column.title}}</span>：
				<searchInput :values.sync="column.grounpColumns" :lists="column.dataList" @click="changeIndex(i)" :class="{'show':showIndex==i}"></searchInput>
			</div>
		</div>
		<div class="footer">
			<div>温馨提示：</div>
			<div>
				<p>1.默认显示复制后可直接使用的数据列，计算项不可以复制，系统引用项系统会自动生成</p>
				<p>2.如不需要复制某列数据，可在下表中取消勾选；如需查看所有列，可点击</p>
			</div>
		</div>
		<div style="margin-top: 38px;padding-bottom: 24px;text-align:center;">
			<el-button type="primary" @click="save()">保存</el-button>
		</div>

		 <el-dialog
			ref=""
			id="dialog1"
			width="850px"
			v-dialogDrag
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			title="温馨提示"
			:visible.sync="dialogheaderVisible"
			>
				<reminder :reminderList.sync="reminderList"></reminder>
			</el-dialog>

	</div>

</template>

<script>
	import bspTable from "@/components/bsp/bsp-table/bsp-table";
	import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
	import searchInput from "@/views/demo/dataImport/template/searchInput.vue";
	import searchBox from "@/views/demo/dataImport/template/searchBox.vue";
	import reminder from "@/views/demo/dataImport/template/reminder.vue";
	import {
		queryWageItems,
		queryOldTemplateHeader,
		queryWageBatchList,
		saveHisBatchData,

	} from "@/api/demo/demo"
	export default {
		name: "dataHistory",
		components: {
			bspTableColumn,
			bspTable,
			searchInput,
			searchBox,
			reminder
		},
		data() {
			return {
				radio: '',
				showIndex: 0,
				dialogheaderVisible:false,
				listQuery: {
					limit: 20,
					page: 1,
					total: 0,
				},
				list: [],
				reminderList:{
					title:'当前正在进行薪资计算，计算完成后将生成发薪和报税数据，请稍后…',
					list:['数据准备','薪资计算','生成发薪报税数据','发薪','报税','查看结果'],
					current:1
				},
				dynamicColumn: [],
				tableColumn: [],
			};
		},
		created() {
			queryWageItems({
				"wageTemplateId": "1246422591577759746"
			}).then(res => {
				this.dynamicColumn = res.data;
					queryOldTemplateHeader({
					"batchId":"1244897053241684051",
					"wageTemplateId":"1246422591577759746"
					}).then(res => {
						this.dynamicColumn.map(column => {
							res.data.map(data => {
								if(column.field==data.field){
									column.grounpColumns = data.dataList;
								}
							})
						})
				})
			})

			queryWageBatchList({
				"groupId": "3",
				"wageTemplateId": "1250664055388180482"
			}).then(res => {
				if(res.msg=='success'){
					this.$message.success('提交成功');
				}else{
					this.$message.error('提交失败');
				}

			})
		},
		watch: {
			dynamicColumn: { //深度监听，可监听到对象、数组的变化
				handler(vals, oldVal) {
					let valArr = JSON.parse(JSON.stringify(vals));
					let valArr1 = valArr.filter(val => {
						return val.grounpColumns.length > 0
					})
					this.tableColumn = valArr1.map(val => {
						val.children = val.grounpColumns;
						delete val.dataList;
						return val;
					})
					this.$refs.accountTable.refreshColumn();
				},
				deep: true //true 深度监听
			}
		},
		methods: {
			save() {
				let tableColumn = []
				this.tableColumn.map(item => {
					item.children.map(item1 => {
						tableColumn.push({
							'field': item1.field
						})
					})
				});
				this.dialogheaderVisible = true;
				saveHisBatchData({
					'orgProcId': '123',
					"groupId": "3",
					"batchId": "1244897053241684051",
					"wageTemplateId": "1246422591577759746",
					'itemList': tableColumn,
					'wageMonth': '2020-04',
					'taxMonth': '2020-04',
					'insuranceMonth': '2020-04'
				}).then(res => {
					console.log(res)
				})
			},
			changeIndex(i) {
				this.showIndex = i;
			},
			changList() {
				if (this.radio == 1) {
					this.dynamicColumn.map((item) => {
						this.$set(item, 'grounpColumns', item.dataList)
					})
				} else {
					this.dynamicColumn.map((item) => {
						this.$set(item, 'grounpColumns', [])
					})
				}
			}
		}
	};
</script>

<style scoped>
	.tips {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
		margin-bottom: 25px;
	}

	.tips>* {
		vertical-align: middle;

	}

	.tips span {
		color: rgba(51, 51, 51, 1);
	}

	.p1 {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.div1 {
		display: flex;
		justify-content: space-between;
		margin-top: 18px;
	}

	.div1>.flex {
		display: flex;
	}

	.seachBox>div {
		height: 34px;
		line-height: 34px;
		width: 45%;
		margin-bottom: 10px;
		white-space: nowrap;
	}

	.seachBox>div span {
		vertical-align: top;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		display: inline-block;
		width: 118px;
		text-align: justify;
		text-align-last: justify;
	}

	.seachBox {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

	}

	.footer {
		display: flex;
		margin-top: 16px;
	}

	.footer div {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.footer p {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
		margin-bottom: 12px;
		text-align: left;
	}
</style>
